export const REACT_APP_CSRF_CUSTOM_CLIENT_SECURE_PREFIX = 'startx';

//FOR DEBUG ONLY!!!
//console.log('DEBUG QA STAND csrfCustomClientPrefix: ', csrfCustomClientPrefix);

export const CSRF_COOKIE_NAME = `__Host-${REACT_APP_CSRF_CUSTOM_CLIENT_SECURE_PREFIX}.x-csrf-token`;
